'use client';

// ChatInput - Creator-specific wrapper around @boty/ui ChatInput
// Provides translated placeholder and creator-specific defaults (2000 char limit)

import { ChatInput as BaseChatInput, type ChatInputProps as BaseChatInputProps } from '@boty/ui';
import { useTranslations } from 'next-intl';

// Re-export base props type for consumers
export type ChatInputProps = Omit<BaseChatInputProps, 'placeholder' | 'sendAriaLabel'>;

const MAX_MESSAGE_LENGTH = 2000;

/**
 * Creator app ChatInput - wraps @boty/ui ChatInput with translations
 *
 * Features:
 * - Input + Send button layout (WhatsApp style)
 * - 16px font on mobile to prevent iOS zoom
 * - Multiline support (max 4 rows auto-expand)
 * - Enter to send, Shift+Enter for newline
 * - Primary color Send button, disabled when empty
 * - Disable during loading
 * - Auto-focus on mount
 * - Clear after sending
 * - 2000 character limit (higher than consumer's 500)
 */
export function ChatInput(props: ChatInputProps) {
  const t = useTranslations('creator.testing');

  return (
    <BaseChatInput
      {...props}
      placeholder={t('chat.placeholder')}
      sendAriaLabel={t('chat.send')}
      maxLength={MAX_MESSAGE_LENGTH}
    />
  );
}

export default ChatInput;
